// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__lyvdv","content":"LoadingScreen_content__ytPCL","spinner":"LoadingScreen_spinner__6BbG-","text":"LoadingScreen_text__zCxwd"};